// extracted by mini-css-extract-plugin
export var arrow = "stickyMessage-module--arrow--a077f fill-tertiary";
export var base = "stickyMessage-module--base--6dce5 transition ease-out duration-500";
export var container = "stickyMessage-module--container--75e14 fixed top-[50svh] z-[99] right-base -translate-y-2/4 hidden xl_block";